import React, { useEffect, useState } from 'react';
import { Alert, Snackbar } from 'components/ui/MaterialAdapter';

const ActivityMonitor = ({ inactivityThreshold = 300000 }) => {
  const [lastActivityTime, setLastActivityTime] = useState(Date.now());
  const [openWarning, setOpenWarning] = useState(false);

  const resetActivity = () => {
    setLastActivityTime(Date.now());
    setOpenWarning(false);
  };

  const handleClose = () => {
    setOpenWarning(false);
  };

  useEffect(() => {
    const events = [
      'mousemove',
      'keypress',
      'click',
      'scroll',
      'mousedown',
      'touchstart',
      'change',   // when selecting dropdowns
      'input',    // when typing in fields
      'focus'     // when focusing on inputs
    ];

    events.forEach((event) => document.addEventListener(event, resetActivity));

    const inactivityCheck = setInterval(() => {
      if (Date.now() - lastActivityTime > inactivityThreshold) {
        setOpenWarning(true);
      }
    }, 1000);

    return () => {
      events.forEach((event) => document.removeEventListener(event, resetActivity));
      clearInterval(inactivityCheck);
    };
  }, [lastActivityTime, inactivityThreshold]);

  return (
    <div>
      <Snackbar
        id="snackbar-warning"
        open={openWarning}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          id="alert-warning"
          onClose={handleClose}
          severity="warning"
          sx={{ width: '100%' }}
        >
          <strong>Warning:</strong> No activity detected!
        </Alert>
      </Snackbar>
    </div>
  );
};

export default ActivityMonitor;
